import React, { useEffect, useState } from 'react';
import axios from '../../axios/AxiosInstance';
import CreateQuotationModal from '../../pages/CreateQuotationModal';
export default function NeedQuotationBuilder({ need, clientId, onClose, onCreated }) {
  const [client, setClient] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    if (!/^[a-f0-9]{24}$/i.test(String(clientId || ''))) {
      setError('Enregistrez ce prospect dans Mes clients avant de créer son devis.');
      return;
    }
    axios.get(`client/${encodeURIComponent(clientId)}`).then(({ data }) => { if (active) setClient(data); })
      .catch(() => { if (active) setError('Impossible de charger le client de ce besoin.'); });
    return () => { active = false; };
  }, [clientId]);
  if (error) return <div role="alert" className="fixed inset-0 z-[100] flex items-center justify-center bg-black/30"><div className="rounded bg-white p-6">{error}<button className="ml-4 underline" onClick={onClose}>Fermer</button></div></div>;
  if (!client) return <div role="status" className="fixed inset-0 z-[100] flex items-center justify-center bg-white/80">Chargement du devis…</div>;
  return <CreateQuotationModal initialNeed={need} client={client} isCreateQuotation setIsCreateQuotation={open => { if (!open) onClose(); }} onCreated={onCreated} />;
}
